export default {"src":"/_next/static/media/how-schedule-generator-works.3bff8f5d.svg","height":500,"width":596,"blurWidth":0,"blurHeight":0};